// Featured photographic images for blog posts — one unique image per post (43 total).
// Realistic, cinematic professional photography on dark wood desk, brand-aligned tones.
import apartmentLeaseRedFlags from "@/assets/blog/post-10-apartment-lease-red-flags.jpg";
import securityDepositRedFlags from "@/assets/blog/post-security-deposit-red-flags.jpg";
import predatoryRenewalClauses from "@/assets/blog/post-predatory-renewal-clauses.jpg";
import residentialLeaseExplained from "@/assets/blog/post-residential-lease-explained.jpg";
import leaseFeesExplained from "@/assets/blog/post-lease-fees-explained.jpg";
import tenantRightsExplained from "@/assets/blog/post-tenant-rights-explained.jpg";
import fairResidentialLeaseTemplate from "@/assets/blog/post-fair-residential-lease-template.jpg";
import monthToMonthLeaseTemplate from "@/assets/blog/post-month-to-month-lease-template.jpg";
import roommateLeaseTemplate from "@/assets/blog/post-roommate-lease-template.jpg";
import ndaRedFlagsToWatchFor from "@/assets/blog/post-nda-red-flags-to-watch-for.jpg";
import mutualVsOneWayNdaRedFlags from "@/assets/blog/post-mutual-vs-one-way-nda-red-flags.jpg";
import ndaNonSolicitTrap from "@/assets/blog/post-nda-non-solicit-trap.jpg";
import ndaExplainedSectionBySection from "@/assets/blog/post-nda-explained-section-by-section.jpg";
import whatCountsAsConfidentialInformation from "@/assets/blog/post-what-counts-as-confidential-information.jpg";
import mutualNdaTemplate from "@/assets/blog/post-mutual-nda-template.jpg";
import oneWayNdaTemplate from "@/assets/blog/post-one-way-nda-template.jpg";
import freelanceContractRedFlags from "@/assets/blog/post-freelance-contract-red-flags.jpg";
import freelancePaymentRedFlags from "@/assets/blog/post-freelance-payment-red-flags.jpg";
import freelanceIpClauseRedFlags from "@/assets/blog/post-freelance-ip-clause-red-flags.jpg";
import freelanceContractExplained from "@/assets/blog/post-freelance-contract-explained.jpg";
import scopeCreepExplained from "@/assets/blog/post-scope-creep-explained.jpg";
import freelanceContractTemplate from "@/assets/blog/post-freelance-contract-template.jpg";
import freelanceSowTemplate from "@/assets/blog/post-freelance-sow-template.jpg";
import employmentOfferRedFlags from "@/assets/blog/post-employment-offer-red-flags.jpg";
import atWillEmploymentRedFlags from "@/assets/blog/post-at-will-employment-red-flags.jpg";
import offerLetterExplained from "@/assets/blog/post-offer-letter-explained.jpg";
import equityVestingExplained from "@/assets/blog/post-equity-vesting-explained.jpg";
import nonCompeteRedFlags from "@/assets/blog/post-non-compete-red-flags.jpg";
import gardenLeaveRedFlags from "@/assets/blog/post-garden-leave-red-flags.jpg";
import nonCompeteExplained from "@/assets/blog/post-non-compete-explained.jpg";
import severanceRedFlags from "@/assets/blog/post-severance-red-flags.jpg";
import severanceAgreementExplained from "@/assets/blog/post-severance-agreement-explained.jpg";
import termsOfServiceRedFlags from "@/assets/blog/post-terms-of-service-red-flags.jpg";
import termsOfServiceExplained from "@/assets/blog/post-terms-of-service-explained.jpg";
import privacyPolicyRedFlags from "@/assets/blog/post-privacy-policy-red-flags.jpg";
import privacyPolicyExplained from "@/assets/blog/post-privacy-policy-explained.jpg";
import saasContractRedFlags from "@/assets/blog/post-saas-contract-red-flags.jpg";
import saasContractExplained from "@/assets/blog/post-saas-contract-explained.jpg";
import independentContractorAgreementTemplate from "@/assets/blog/post-independent-contractor-agreement-template.jpg";
import internationalContractorTemplate from "@/assets/blog/post-international-contractor-template.jpg";
import commercialLeaseRedFlags from "@/assets/blog/post-commercial-lease-red-flags.jpg";
import commercialLeaseExplained from "@/assets/blog/post-commercial-lease-explained.jpg";
import commercialLeaseLoiTemplate from "@/assets/blog/post-commercial-lease-loi-template.jpg";

const POST_IMAGES: Record<string, string> = {
  "10-apartment-lease-red-flags": apartmentLeaseRedFlags,
  "security-deposit-red-flags": securityDepositRedFlags,
  "predatory-renewal-clauses": predatoryRenewalClauses,
  "residential-lease-explained": residentialLeaseExplained,
  "lease-fees-explained": leaseFeesExplained,
  "tenant-rights-explained": tenantRightsExplained,
  "fair-residential-lease-template": fairResidentialLeaseTemplate,
  "month-to-month-lease-template": monthToMonthLeaseTemplate,
  "roommate-lease-template": roommateLeaseTemplate,
  "nda-red-flags-to-watch-for": ndaRedFlagsToWatchFor,
  "mutual-vs-one-way-nda-red-flags": mutualVsOneWayNdaRedFlags,
  "nda-non-solicit-trap": ndaNonSolicitTrap,
  "nda-explained-section-by-section": ndaExplainedSectionBySection,
  "what-counts-as-confidential-information": whatCountsAsConfidentialInformation,
  "mutual-nda-template": mutualNdaTemplate,
  "one-way-nda-template": oneWayNdaTemplate,
  "freelance-contract-red-flags": freelanceContractRedFlags,
  "freelance-payment-red-flags": freelancePaymentRedFlags,
  "freelance-ip-clause-red-flags": freelanceIpClauseRedFlags,
  "freelance-contract-explained": freelanceContractExplained,
  "scope-creep-explained": scopeCreepExplained,
  "freelance-contract-template": freelanceContractTemplate,
  "freelance-sow-template": freelanceSowTemplate,
  "employment-offer-red-flags": employmentOfferRedFlags,
  "at-will-employment-red-flags": atWillEmploymentRedFlags,
  "offer-letter-explained": offerLetterExplained,
  "equity-vesting-explained": equityVestingExplained,
  "non-compete-red-flags": nonCompeteRedFlags,
  "garden-leave-red-flags": gardenLeaveRedFlags,
  "non-compete-explained": nonCompeteExplained,
  "severance-red-flags": severanceRedFlags,
  "severance-agreement-explained": severanceAgreementExplained,
  "terms-of-service-red-flags": termsOfServiceRedFlags,
  "terms-of-service-explained": termsOfServiceExplained,
  "privacy-policy-red-flags": privacyPolicyRedFlags,
  "privacy-policy-explained": privacyPolicyExplained,
  "saas-contract-red-flags": saasContractRedFlags,
  "saas-contract-explained": saasContractExplained,
  "independent-contractor-agreement-template": independentContractorAgreementTemplate,
  "international-contractor-template": internationalContractorTemplate,
  "commercial-lease-red-flags": commercialLeaseRedFlags,
  "commercial-lease-explained": commercialLeaseExplained,
  "commercial-lease-loi-template": commercialLeaseLoiTemplate,
};

/** Featured photographic image URL for a given post slug.
 *  Falls back to the residential lease image if no match (brand-consistent). */
export function getPostImage(postSlug: string): string {
  return POST_IMAGES[postSlug] ?? residentialLeaseExplained;
}

/** @deprecated Kept for backward compatibility — prefer `getPostImage(postSlug)`. */
export function getCategoryImage(_categorySlug: string): string {
  return residentialLeaseExplained;
}
